import template from './chargecodes.html';
import controller from './chargecodes.controller';

let chargecodesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default chargecodesComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/chargecodes/chargecodes.component.js